import React from "react";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MUISwitch from "@mui/material/Switch";
import { getClassName } from "@sscs/utils";
import styles from "./switch.module.scss";
const FRAME_HEIGHT = {
    small: styles.small,
    medium: styles.medium,
    large: styles.large,
};
const Switch = ({ label, title, variant = "outlined", className, ...props }) => { var _a; return (React.createElement(FormControl, { variant: variant, className: className },
    title && (React.createElement(InputLabel, { shrink: true, className: styles.label }, title)),
    React.createElement("div", { className: getClassName(styles.frame, styles[variant], FRAME_HEIGHT[(_a = props.size) !== null && _a !== void 0 ? _a : "medium"]) },
        variant === "outlined" && (React.createElement("fieldset", { "aria-hidden": true, className: styles.notch },
            React.createElement("legend", null, title && React.createElement("span", null, title)))),
        React.createElement(FormControlLabel, { control: React.createElement(MUISwitch, { ...props, color: "default" }), label: label })))); };
export default Switch;
//# sourceMappingURL=Switch.js.map